module.exports = "/fonts/Simple-Line-Icons.eot?f33df365d6d0255b586f2920355e94d7";